import {
    IDashboardTileComponentProps,
    IGroupTileInfo,
    ILinkTileInfo,
    TBasicLinkTileConfig
} from "@components/dashboard";
import DashboardTileBackground from "@components/dashboard/DashboardTileBackground";
import SimpleDialog from "@components/dialog/SimpleDialog";
import { getIcon } from "@components/icon";
import { getInfoValue } from "@components/smart/FieldInfo";
import {
    DialogTileWrapper,
    GroupTileBody,
    GroupTileDialogBody,
    GroupTileDialogItems,
    GroupTileItemBackground,
    GroupTileItems,
    GroupTileTitle
} from "@components/tiles/groupTile/GroupTile.styles";
import LinkTile from "@components/tiles/linkTile";
import {
    IconHeight,
    IconWidth,
    StyledLinkTileTitle,
    StyledLinkTileTitleWrapper
} from "@components/tiles/linkTile/LinkTile.styles";
import { WithOData, withOData } from "@odata/withOData";
import { AppContext } from "contexts/appContext/AppContext.types";
import React, { memo, useCallback, useContext, useState } from "react";

import TestIds from "../../../testIds";

interface IProps extends IDashboardTileComponentProps<IGroupTileInfo>, WithOData {
}

const SMALL_TILE_LIMIT = 4;

const GroupTile: React.FC<IProps> = (props: IProps) => {
    const [isDialogOpened, setIsDialogOpened] = useState<boolean>(false);
    const context = useContext(AppContext);

    const renderIcon = (item: TBasicLinkTileConfig) => {
        const size = "26px";
        const Icon = item.iconName && getIcon(item.iconName);

        return (
            <GroupTileItemBackground>
                {Icon && (<Icon width={size} height={size}/>)}
            </GroupTileItemBackground>
        );
    };

    const handleOpen = useCallback(() => {
        setIsDialogOpened(true);
    }, []);

    const handleClose = useCallback(() => {
        setIsDialogOpened(false);
    }, []);

    const items = props.info.items?.filter(item => {
        return getInfoValue(item, "isVisible", { context }) !== false;
    });

    const isSmall = items?.length <= SMALL_TILE_LIMIT;

    return (
        <>
            <DashboardTileBackground isInteractive backgroundColor={props.info.backgroundColor} onClick={handleOpen}>
                <GroupTileBody>
                    <GroupTileItems>
                        {items?.slice(0, 4).map(item => {
                            return renderIcon(item);
                        })}
                    </GroupTileItems>
                    <GroupTileTitle>
                        {props.info.title}
                    </GroupTileTitle>
                </GroupTileBody>
            </DashboardTileBackground>
            {isDialogOpened &&
                <SimpleDialog
                    onClose={handleClose}
                    onConfirm={handleClose}>
                    <GroupTileDialogBody isSmall={isSmall} data-testid={TestIds.DashboardGroupTileDialog}>
                        <GroupTileDialogItems>
                            {items?.map(item => {
                                return (
                                    <DialogTileWrapper data-testid={TestIds.DashboardTile}>
                                        <LinkTile info={item as ILinkTileInfo}/>
                                    </DialogTileWrapper>
                                );
                            })}
                        </GroupTileDialogItems>
                    </GroupTileDialogBody>
                </SimpleDialog>
            }
        </>
    );
};


export default memo(withOData(GroupTile));